module.exports = __webpack_public_path__ + "15_hair_brown.146311fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/15_hair_brown.png
// module id = H92d
// module chunks = 0